import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { TextToolbarComponent } from './components/text-toolbar/text-toolbar.component';

@NgModule({
  declarations: [TextEditorComponent, TextToolbarComponent],
  imports: [CommonModule],
  exports: [TextEditorComponent, TextToolbarComponent],
})
export class EditorsModule {}
